import { useQuery } from "react-query";
import BookingService from "../../services/bookingService";

export const useFetchBooking = (bookingId?: string) =>
  useQuery({
    queryKey: ["booking", bookingId],
    queryFn: () =>
      bookingId ? BookingService.getBooking(bookingId) : undefined,
    enabled: !!bookingId,
  });
